import {ForwardedRef, forwardRef, MouseEventHandler, RefObject} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

export interface GridProps {
  children?: React.ReactNode
  id?: string
  className?: string
  ref?: RefObject<HTMLDivElement>
  onMouseEnter?: MouseEventHandler<unknown> | undefined
  onMouseLeave?: MouseEventHandler<unknown> | undefined
  container?: boolean
}

const Grid = forwardRef(
  (
    {children, id, onMouseEnter, onMouseLeave, className, container}: GridProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <div
      ref={ref}
      id={id}
      className={cn(
        'w-full gap-4',
        container && 'grid grid-cols-12',
        !container && 'col-span-2',
        className
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {children}
    </div>
  )
)

Grid.displayName = 'Grid'

export default Grid
